import React from 'react';
import PropTypes from 'prop-types';

import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import {
  bodyCellSx,
  dateHeadCellSx,
  ellipsisCellSx,
  emptyCellSx,
  linkSx,
  rowSx,
  statusHeadCellSx,
  subjectiveHeadCellSx,
  tableContainerSx,
  tableSx
} from './SoapPastStyles';

const SoapPastTable = ({
  rows,
  latestEncounterId,
  onEncounterClick
}) => {
  return (
    <TableContainer sx={tableContainerSx}>
      <Table
        stickyHeader
        size="small"
        sx={tableSx}>
        <TableHead>
          <TableRow>
            <TableCell sx={dateHeadCellSx}>
              Date
            </TableCell>

            <TableCell sx={subjectiveHeadCellSx}>
              Subjective
            </TableCell>

            <TableCell sx={statusHeadCellSx}>
              Status
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={3}
                sx={emptyCellSx}>
                No past SOAP notes
              </TableCell>
            </TableRow>
          )}

          {rows.map(row => {
            const isSigned = row.status === 'signed';

            const isLatestDraft =
              row.id === latestEncounterId &&
              !isSigned;

            return (
              <TableRow
                key={row.id}
                hover
                onClick={() => onEncounterClick(row)}
                sx={rowSx}>
                <TableCell sx={bodyCellSx}>
                  {row.date || '-'}
                </TableCell>

                <TableCell
                  sx={ellipsisCellSx}
                  title={row.subjective || ''}>
                  {isLatestDraft ? (
                    <Link
                      component="button"
                      type="button"
                      underline="always"
                      sx={linkSx}
                      onClick={event => {
                        event.stopPropagation();
                        onEncounterClick(row);
                      }}>
                      {row.subjective || '-'}
                    </Link>
                  ) : (
                    row.subjective || '-'
                  )}
                </TableCell>

                <TableCell
                  sx={ellipsisCellSx}
                  title={
                    isSigned
                      ? `Signed by: ${row.signedBy || ''}`
                      : 'Signed by:'
                  }>
                  {isSigned
                    ? `Signed by: ${row.signedBy || '-'}`
                    : 'Signed by:'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SoapPastTable.propTypes = {
  rows: PropTypes.array.isRequired,

  latestEncounterId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  onEncounterClick: PropTypes.func.isRequired
};

export default SoapPastTable;